import React from "react";
import Navigation from "./navigation";
import Sidebar from "../SideBar/sideBar";
export default function RootNavigation() {
  return (
    <>
     <Sidebar/>
      <Navigation />
    </>
  );
}
